import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AppUtilService } from '@gah-core/services/app-util.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private userStoreService: UserStoreService,
    private router: Router,
    private utilService: AppUtilService
  ) {}

  /**
   * @inheritdoc
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      headers: request.headers
        .set('Role', `${this.userStoreService.userState?.groupRolesId}`)
        .set('accept-language', this.utilService.getCurrentAppLanguage()),
      withCredentials: true,
    });

    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 403) {
              return;
            }
            if (this.userStoreService.userState?.isAuthenticated)
              this.router.navigate(['unauthorized']);
          }
        }
      )
    );
  }
}
